
import { logger } from '../../infrastructure/logger';

export const loggerService = {
    /**
     * Logs a non-fatal error (e.g. to Crashlytics)
     */
    recordError(error: Error, context?: Record<string, unknown>) {
        // In production: firebase.crashlytics().recordError(error);
        logger.error('[Logger] Error recorded', error, context);
    },

    /**
     * Logs a specific user action (e.g. to Firebase Analytics)
     */
    logEvent(eventName: string, params?: Record<string, unknown>) {
        // In production: firebase.analytics().logEvent(eventName, params);
        logger.debug(`[Analytics] ${eventName}`, params);
    },

    /**
     * Identifies the user for analytics sessions
     */
    setUser(userId: string) {
        // In production: firebase.analytics().setUserId(userId);
        // firebase.crashlytics().setUserId(userId);
        logger.debug(`[Logger] User set: ${userId}`);
    }
};
